                                                                                <template>
  <v-form id="bookingConfirmationSection">
    <v-container v-if="GetBookedDetails() !== null">
      <v-col cols="12" class="mb-0 mt-0 pb-0 pt-0">
        <div class="text-h5 font-weight-medium" v-if="GetBookedDetails().paymentMode !== 'BankTransfer' 
        && GetBookedDetails().paymentMode !== 'PaymentPending'">
          Your Booking #: {{ GetBookedDetails() !== null ? GetBookedDetails().orderCode
          : '--------'
          }} is Confirmed.
          <!-- Your Booking from {{ formatDate(GetArrival()) }} to
          {{ formatDate(GetDeparture()) }} is Confirmed.  -->
          <br /> Booking Voucher will be sent to your email address provided.
        </div>
        <div class="text-h5 font-weight-medium" v-if="GetBookedDetails().paymentMode === 'BankTransfer' || GetBookedDetails().paymentMode === 'PaymentPending'">
          Your Booking #: {{ GetBookedDetails() !== null ? GetBookedDetails().orderCode
          : '--------'
          }} is on hold.
          <!-- Your Booking from {{ formatDate(GetArrival()) }} to
          {{ formatDate(GetDeparture()) }} is on hold.  -->
          <br /> Please make payment in accordance with hotel booking policy to confirm your booking.
        </div>
      </v-col>
      <v-row no-gutters class="mt-4">
        <v-col cols="12">
          <div class="text-h5 font-weight-black">Booking #:{{ GetBookedDetails() !== null ? GetBookedDetails().orderCode
          : '--------'
          }}
          
          <!-- <v-btn
        class="ma-2"
        color="blue-lighten-2"
        icon
        variant="text"
        @click="copyOrderCode"> -->
      <v-tooltip
          v-model="showToolTip"
          location="top"
        >
          <template v-slot:activator="{ props }">
            <v-btn
            @click="copyOrderCode"
              icon
              v-bind="props"
            >
            <v-icon> mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>{{ copySuccessMessage }}</span>
        </v-tooltip>
      
    <!-- </v-btn> -->
      

    
    </div>
        </v-col>
      </v-row>
      <v-row v-if="mobileView">
        <v-col cols="4"></v-col>
        <v-col cols="8">
          <a style="display: none;" v-bind:href="'http://bookingsuccess'" ref="clickToMenu"></a>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">First Name:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.firstName }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Last Name:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.lastName }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Email:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.email }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Country:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails() !== null ?
        GetCountry(GetBookedDetails().beGuest.countryCode)().name : "Undefined" }}</v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Phone:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().beGuest.mobileNumber }}</v-col>
      </v-row>
      <v-row no-gutters class="mb-2">
        <v-col lg="2" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Special Request:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">{{ GetBookedDetails().notes }}</v-col>
      </v-row>

      <v-row no-gutters class="mt-4">
        <v-col lg="3" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Accomodation Total:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">
          <div class="text-subtitle-2 font-weight-black">{{ GetBookedDetails().displayGrandTotalAmount }}</div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="3" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Grand Total:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">
          <div class="text-subtitle-2 font-weight-black">{{ GetBookedDetails().displayGrandTotalAmount }}</div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col lg="3" md="4" sm="6" xs="12">
          <div class="text-subtitle-2">Deposit:</div>
        </v-col>
        <v-col lg="4" md="4" sm="6" xs="12">
          <div class="text-subtitle-2 font-weight-black">{{ GetBookedDetails().displayDepositAmount }}</div>
        </v-col>
      </v-row>
      <!-- <template v-for="(roomStay, iroomStay) in GetBookedDetails().beRoomStays">
        <v-row no-gutters class="mt-4" :key="iroomStay + 'roomName-col'">
          <v-col lg="2" md="4" sm="6" xs="12">
            <div class="text-subtitle-2">Room Name:</div>
          </v-col>
          <v-col lg="4" md="4" sm="6" xs="12">{{roomStay.beRoomType.name}}</v-col>
        </v-row>
        <v-row no-gutters :key="iroomStay + 'rateName-col'">
          <v-col lg="2" md="4" sm="6" xs="12">
            <div class="text-subtitle-2">Rate Name:</div>
          </v-col>
          <v-col lg="4" md="4" sm="6" xs="12">{{roomStay.beRoomTypeRatePlan.name}}</v-col>
        </v-row>
        <v-row no-gutters :key="iroomStay + 'occupancy-col'">
          <v-col lg="2" md="4" sm="6" xs="12">
            <div class="text-subtitle-2">Occupancy:</div>
          </v-col>
          <v-col lg="4" md="4" sm="6" xs="12"></v-col>
        </v-row>
      </template> -->
      <template v-for="(room, iroom) in GetBookedDetails().beRoomStays">
        <rate-breakdown :Room="room" :key="iroom + 'breakdown-section'"></rate-breakdown>

      </template>
      <!-- <v-col cols="12" class="d-block mb-0 mt-0 pb-0 pt-0">
        <div class="text-subtitle-2">Payment Method</div>
      </v-col>
      <v-col lg="4" md="4" sm="6" xs="12"> </v-col>
      <v-col cols="12">
        <div class="text-body-2 d-inline">Total Payment:</div>
        <div class="text-body-1 d-inline font-weight-black">S$15.00</div>
      </v-col>
      <v-divider></v-divider> -->
      <input hidden :value="isShowDetails">
    </v-container>
  </v-form>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

import RateBreakdown from '../Booking/RoomRateBreakdown.vue';

export default {
  data: () => {
    return {
      mobileView: false,
      copySuccessMessage: '',
      showToolTip: false
    };
  },
  props: {
    OrderCode: {
      type: String,
      require: false,
    }
  },
  components: {
    RateBreakdown
  },
  methods: {
    formatDate(date) {
      return moment(date).format("dddd Do MMMM YYYY");
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
    },
    copyOrderCode: function(){
      let orderCode = this.GetBookedDetails().orderCode;

      navigator.clipboard.writeText(orderCode)
        .then(() => {
          this.showToolTip = true;
          this.copySuccessMessage = 'Order Code copied to clipboard!';
          setTimeout(() => {
            this.copySuccessMessage = ''; // Clear message after 2 seconds
          this.showToolTip = false;
          }, 2000);
        })
        .catch(err => {
          console.error('Failed to copy Order Code: ', err);
          this.copySuccessMessage = 'Failed to copy Order Code';
        });
    }
  },
  beforeMount: function () {

    // this.$store.dispatch("setPropertyCode", this.PropertyCode);

    this.$store.dispatch("getBookingDetailsById", this.OrderCode);
  },
  computed: {
    ...mapGetters([
      "GetArrival",
      "GetDeparture",
      "GetGuest",
      'GetBookingSummary',
      'GetBookingInfo',
      'GetBookedDetails',
      'GetCountry',
      'GetAjaxingRooms']),
      isShowDetails: function(){
        if(this.GetBookedDetails()){
          // Check if the element exists and then scroll to it
            const targetElement = document.querySelector('#bookingConfirmationSection');
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        }

        return this.GetBookedDetails() !== null;
      }
  },
  created() {
    this.handleView();
  },
  mounted() {


    // Set a delay (in milliseconds) before triggering the click
    const delayMilliseconds = 20000; // 20 seconds

    // Use the setTimeout function to trigger the click after the delay
    // setTimeout(() => {
    //   // Get the reference to the anchor element using $refs
    //   const link = this.$refs.clickToMenu;
      
    //   // Trigger the click event on the anchor element
    //   link.click();
    // }, delayMilliseconds);

  
  }
};
</script>